<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 size py-3">
                <v-card-text class="px-0">
                    
                    <!-- Administrative History -->
                    <v-card elevation="4" class="mx-3" v-permission="'guides.show'">
                        <v-row class="px-5 pt-1 pb-5">
                            <v-col cols="12" align="center" justify="center">    
                                <h2 class="blue_accent--text text-uppercase">{{ $t('guides_sales.history') }} </h2>
                            </v-col>
                        </v-row>
                        <v-row class="mx-2 px-2 pb-2 mt-1">
                            <v-col cols="10">
                                <v-row align="center" justify="center">
                                    <v-col cols="4" class="py-0">
                                        <client-selector class="py-0" ref="clientSelector" @getClients="v => items.clients = v" :rules="rules_required" :full_catalog="true" :guides_service="true"></client-selector>  
                                    </v-col>
                                    <v-col cols="4" class="py-0">
                                        <datepicker :open_dialog="menu_history_initial_date" :model="history.initial_date" :label="$t('guides_sales.initial_date')" @model="updateDate('history.initial_date', $event)" :rules_required="rules_required"></datepicker>
                                    </v-col>
                                    <v-col cols="4" class="py-0">
                                        <datepicker :open_dialog="menu_history_final_date" :model="history.final_date" :label="$t('guides_sales.final_date')" @model="updateDate('history.final_date', $event)" :rules_required="rules_required"></datepicker>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="2" class="pt-0" align="center" justify="center">
                                <v-btn class="right white_highlight--text pt-0" color="secondary" @click="exportHistory">
                                    {{ $t('guides_sales.export') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>

                    <!-- Balance Guides -->
                     <v-card elevation="4" class="mx-3 mt-8" v-permission="'balance_shipping_guides.show'"> 
                        <v-row class="px-5 pt-1 pb-5">
                            <v-col cols="12" align="center" justify="center">    
                                <h2 class="blue_accent--text text-uppercase">{{ $t('guides_sales.balance') }} </h2>
                            </v-col>
                        </v-row>
                        <v-row class="mx-2 px-2 pb-2 mt-1">
                            <v-col cols="10">
                                <v-row align="center" justify="center">
                                    <v-col cols="4" class="py-0">
                                        <client-selector class="py-0" ref="clientSelector" @getClients="v => items.clients = v" :rules="rules_required" :full_catalog="true" :guides_service="true"></client-selector>  
                                    </v-col>
                                    <v-col cols="4" class="py-0">
                                        <datepicker :open_dialog="menu_balance_initial_date" :model="balance.initial_date" :label="$t('guides_sales.initial_date')" @model="updateDate('balance.initial_date', $event)" :rules_required="rules_required"></datepicker>
                                    </v-col>
                                    <v-col cols="4" class="py-0">
                                        <datepicker :open_dialog="menu_balance_final_date" :model="balance.final_date" :label="$t('guides_sales.final_date')" @model="updateDate('balance.final_date', $event)" :rules_required="rules_required"></datepicker>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="2" class="pt-0" align="center" justify="center">
                                <v-btn class="right white_highlight--text pt-0" color="secondary" @click="exportBalanceGuides">
                                    {{ $t('guides_sales.export') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>

                    <!-- Shipping Guides Payments -->
                    <v-card elevation="4" class="mx-3 mt-8" v-permission="'guides.show'">
                        <v-row class="px-5 pt-1 pb-5">
                            <v-col cols="12" align="center" justify="center">    
                                <h2 class="blue_accent--text text-uppercase">{{ $t('guides_sales.shipping_guides_payments') }} </h2>
                            </v-col>
                        </v-row>
                        <v-row class="mx-2 px-2 pb-2 mt-1">
                            <v-col cols="10">
                                <v-row align="center" justify="center">
                                    <v-col cols="6" class="py-0">
                                        <v-file-input prepend-icon="" append-outer-icon="cloud_upload" class="cloud_upload py-0" :clearable="false" v-model="shippingGuides.file" accept=".csv" :label="$t('guides_sales.shipping_guides_file')"></v-file-input>
                                    </v-col>
                                    <v-col cols="6" class="py-0">
                                        <datepicker :open_dialog="menu_shipping_guide_payments_date" :model="shippingGuides.date" :label="$t('guides_sales.date')" @model="updateDate('shippingGuides.date', $event)" :rules_required="rules_required"></datepicker>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="2" class="pt-0" align="center" justify="center">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="mx-1" small color="secondary" fab dark v-bind="attrs" v-on="on" @click="shipping_guides_modal = true">
                                            <v-icon aria-hidden="false" color="white" small>
                                                help
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('guides_sales.help') }}</span>
                                </v-tooltip>
                                <v-btn class="right white_highlight--text pt-0" color="secondary" @click="shippingGuidesImport">
                                    {{ $t('guides_sales.import') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>

                    <!-- Shipping Guides Billing -->
                    <v-card elevation="4" class="mx-3 mt-8" v-permission="'guides.show'">
                        <v-row class="px-5 pt-1 pb-5">
                            <v-col cols="12" align="center" justify="center">    
                                <h2 class="blue_accent--text text-uppercase">{{ $t('guides_sales.shipping_guides_billing') }} </h2>
                            </v-col>
                        </v-row>
                        <v-row class="mx-2 px-2 pb-2 mt-1">
                            <v-col cols="10">
                                <v-row align="center" justify="center">
                                    <v-col cols="6" class="py-0">
                                        <v-file-input prepend-icon="" append-outer-icon="cloud_upload" class="cloud_upload py-0" :clearable="false" v-model="shippingGuidesBilling.file" accept=".csv" :label="$t('guides_sales.shipping_guides_billing_file')"></v-file-input>
                                    </v-col>
                                    <v-col cols="6" class="py-0">
                                        <datepicker :open_dialog="menu_shipping_guide_billing_date" :model="shippingGuidesBilling.date" :label="$t('guides_sales.date')" @model="updateDate('shippingGuidesBilling.date', $event)" :rules_required="rules_required"></datepicker>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="2" class="pt-0" align="center" justify="center">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="mx-1" small color="secondary" fab dark v-bind="attrs" v-on="on" @click="shipping_guides_modal = true">
                                            <v-icon aria-hidden="false" color="white" small>
                                                help
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('guides_sales.help') }}</span>
                                </v-tooltip>
                                <v-btn class="right white_highlight--text pt-0" color="secondary" @click="shippingGuidesImport">
                                    {{ $t('guides_sales.import') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>

                </v-card-text>
            </v-card>
        </v-container>     

        <v-dialog v-model="shipping_guides_modal" persistent max-width="90%">
            <v-card>
                <v-card-title class="justify-center">
                    <v-spacer></v-spacer>
                    {{ $t('guides_sales.guides_fees') }}
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" small icon @click="shipping_guides_modal = false"><v-icon small>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <p class="py-0 my-0">1.- Conserve todos los encabezados en el orden presentado y sin modificarlos.</p> 
                    <p class="py-0 my-0">2.- Llene la información de acuerdo al campo solicitado, no utilice comas en ninguno de los campos, evite el uso de signos de interrogación, comillas o signos de admiración.</p> 
                    <p class="py-0 my-0">3.- A continuación se muestra una línea de ejemplo para familiarizarse con el formato.</p> 
                    <p class="py-0 my-0">4.- El archivo de cobranza debe ser formato CSV.</p> 
                    <p>5.- Si el campo presenta la leyenda 'Opcional' este campo puede ir vacío.</p> 
                    <p class="py-0 my-0">Columnas: </p>
                    <v-simple-table fixed-header>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <!-- ,,,,,,,, -->
                                    <th class="text-left" style="padding: 0 5px !important;">guia_de_rastreo</th>
                                    <th class="text-left" style="padding: 0 5px !important;">envio</th>
                                    <th class="text-left" style="padding: 0 5px !important;">retorno</th>
                                    <th class="text-left" style="padding: 0 5px !important;">paquete_xl</th>
                                    <th class="text-left" style="padding: 0 5px !important;">zona_ext</th>
                                    <th class="text-left" style="padding: 0 5px !important;">correccion</th>
                                    <th class="text-left" style="padding: 0 5px !important;">reco_sabatina</th>
                                    <th class="text-left" style="padding: 0 5px !important;">exceso_peso</th>
                                    <th class="text-left" style="padding: 0 5px !important;">seguro</th>
                                    </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1324655067</td>
                                    <td>50</td>
                                    <td>55</td>
                                    <td>55</td>
                                    <td>55</td>
                                    <td>55</td>
                                    <td>55</td>
                                    <td>55</td>
                                    <td>55</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-row align="center" justify="center" class="my-3">
                        <v-btn color="secondary" class="white_highlight--text" @click="shipping_guides_modal = false">
                            {{ $t('guides_sales.close') }}
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
import FileSaver from 'file-saver';
import { downloadGuideHistoryUseCase } from '../application/use_cases/download_guide_history_use_case';
import { downloadBalanceHistoryUseCase } from '../application/use_cases/download_guide_balance_use_case';
import { HttpGuideRepository } from '../infrastructure/repositories/guide_repository';
import { loadPaymentsGuidesUseCase } from '../application/use_cases/load_payments_guides_use_case';
export default {
    computed:{
        client: function(){
            return this.$store.state.clientId
        },
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
    },
    data(){
        return {            
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            history: {
                client_id: "",
                initial_date: "",
                final_date: ""
            },
            balance: {
                type: "cod",
                client_id: "",
                initial_date: "",
                final_date: ""
            },
            shippingGuides: {
                file: [],
                date: ""
            },
            shippingGuidesBilling: {
                file: [],
                date: ""
            },
            menu_history_final_date: false,
            menu_history_initial_date: false,

            menu_balance_final_date: false,
            menu_balance_initial_date: false,

            menu_shipping_guide_payments_date: false,
            menu_shipping_guide_billing_date: false,
            shipping_guides_modal: false, 
        }
    },
    mounted(){
        this.$store.state.module = "headers.guides_sales";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        updateDate(model, new_date){
            this[model.split(".")[0]][model.split(".")[1]] = new_date;
        },
        async exportHistory(){
            this.history.client_id = this.$store.state.clientId;
      
            if(this.history.client_id != "" && this.history.initial_date != "" && this.history.final_date != ""){
                try {
                    const res = await downloadGuideHistoryUseCase(this.history.client_id, this.history.initial_date, this.history.final_date, HttpGuideRepository)
                        
                    FileSaver.saveAs(res.data.success.arguments.file, this.$store.state.clientName + '_guides_history_report.xlsx');
                } catch (e) {
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e.response == null? e : e.response.data.fault.message
                    }
                }
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('guides_sales.export_error')
                };
            }
        },
        async exportBalanceGuides(){
            this.balance.client_id = this.$store.state.clientId;
            
            if(this.balance.client_id != "" && this.balance.initial_date != "" && this.balance.final_date != "" && this.balance.type != ""){
                try {
                    const res = await downloadBalanceHistoryUseCase(this.balance.client_id, this.balance.initial_date, this.balance.final_date, HttpGuideRepository)
                        
                    FileSaver.saveAs(res.data.success.arguments.file, this.$store.state.clientName + '_balance_guias_' + this.balance.final_date + '.xlsx');
                } catch (e) {
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e.response == null? e : e.response.data.fault.message
                    }
                }
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('guides_sales.export_error')
                };
            }
        },
        async shippingGuidesImport(){
            const formData = new FormData();
            formData.append('file', this.shippingGuides.file);
            formData.append('date', this.shippingGuides.date);

            try {
                const res = await loadPaymentsGuidesUseCase(formData, HttpGuideRepository)
                res;    
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: res.data.success.message
                };   

                this.shippingGuides.file = [];
                this.shippingGuides.date = "";
            } catch (e) {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
    },
    watch:{ }
}
</script>

<style>

</style>